import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "21",
  height: "21",
  viewBox: "0 0 21 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g clip-path=\"url(#clip0_6514_42937)\"><path d=\"M1.33398 14.3172L10.5007 14.3188L19.6673 14.3164C19.6673 15.478 18.875 17.6489 17.1816 17.6489L10.5007 17.6497H3.81968C2.12628 17.6497 1.33396 15.4789 1.33398 14.3172Z\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linejoin=\"round\"></path><path d=\"M2.16602 14.3177C2.16602 11.6335 4.06252 5.98438 10.4993 5.98438C16.9362 5.98438 18.8327 11.6335 18.8327 14.3177\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linejoin=\"round\"></path><ellipse cx=\"10.5007\" cy=\"4.31901\" rx=\"1.66667\" ry=\"1.66667\" stroke=\"currentColor\" stroke-width=\"1.5\"></ellipse></g><defs><clipPath id=\"clip0_6514_42937\"><rect width=\"20\" height=\"20\" fill=\"white\" transform=\"translate(0.5 0.984375)\"></rect></clipPath></defs>", 2)
  ]))]))
}
export default { render: render }